import type { TestSeriesResponse } from '../types'

/** Cover image URL from series metadata ("image", 1024x1024); undefined if absent or not http(s) */
export function getSeriesImage(series: TestSeriesResponse): string | undefined {
  const image = series.metadata?.image
  return typeof image === 'string' && /^https?:\/\//i.test(image) ? image : undefined
}
